import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Component for protecting routes based on authentication and role
export const ProtectedRoute = ({ children, requiredRole = null, allowedRoles = null }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="spinner"></div>
        <span className="ml-4 text-lg">Loading...</span>
      </div>
    );
  }

  // Check if user is authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Check if user's role is in allowed roles
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

// Admin-only route protection
export const AdminRoute = ({ children }) => {
  return <ProtectedRoute requiredRole="admin">{children}</ProtectedRoute>;
};

// Customer and Admin route protection
export const CustomerRoute = ({ children }) => {
  return <ProtectedRoute allowedRoles={['customer', 'admin']}>{children}</ProtectedRoute>;
};

// Viewer, Customer and Admin route protection
export const ViewerRoute = ({ children }) => {
  return <ProtectedRoute allowedRoles={['viewer', 'customer', 'admin']}>{children}</ProtectedRoute>;
};